import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userRoles } from "@awe-web/shared/lib";
import { useTranslation } from "@awe-web/shared/lib";

import { B2C_Login, B2B_Login, B2B_SelectStationAndTime, B2C_SelectStationAndTime } from "../routes.js";
import { getUserRole } from "../../user/store.js";
import { isUserRoleAllowed } from "../util.js";
import { openModal } from "../../app/actions.js";

const TITLE_B2C_INSTEAD_OF_B2B = "ALG0000205";
const MESSAGE_B2C_INSTEAD_OF_B2B = "ALG0000206";

const TITLE_B2B_INSTEAD_OF_B2C = "ALG0000207";
const MESSAGE_B2B_INSTEAD_OF_B2C = "ALG0000208";

const TITLE_B2C_INSTEAD_OF_ANONYMOUS = "ALG0000211";
const MESSAGE_B2C_INSTEAD_OF_ANONYMOUS = "ALG0000212";

const TITLE_B2B_INSTEAD_OF_ANONYMOUS = "ALG0000209";
const MESSAGE_B2B_INSTEAD_OF_ANONYMOUS = "ALG0000210";

const BUTTON_LABEL = "ALG0000213";

export default function AuthRoute() {

  const { translate } = useTranslation();
  const location = useLocation();
  const userRole = useSelector((state) => getUserRole(state));
  const dispatch = useDispatch();

  if (isUserRoleAllowed(userRole, location)) {
    return <Outlet />;
  }

  switch (userRole) {
    case userRoles.ANONYMOUS: {
      return isUserRoleAllowed(userRoles.B2C, location)
        ? <Navigate to={B2C_Login.path()} state={{ from: location }} replace />
        : <Navigate to={B2B_Login.path()} state={{ from: location }} replace />;
    }

    case userRoles.B2C: {
      if (isUserRoleAllowed(userRoles.B2B, location)) {
        dispatch(openModal(
          translate(TITLE_B2C_INSTEAD_OF_B2B),
          translate(MESSAGE_B2C_INSTEAD_OF_B2B),
          translate(BUTTON_LABEL)
        ));
      }
      else {
        dispatch(openModal(
          translate(TITLE_B2C_INSTEAD_OF_ANONYMOUS),
          translate(MESSAGE_B2C_INSTEAD_OF_ANONYMOUS),
          translate(BUTTON_LABEL)
        ));
      }

      return <Navigate to={B2C_SelectStationAndTime.path()} state={{ from: location }} replace />;
    }

    case userRoles.B2B: {
      if (isUserRoleAllowed(userRoles.B2C, location)) {
        dispatch(openModal(
          translate(TITLE_B2B_INSTEAD_OF_B2C),
          translate(MESSAGE_B2B_INSTEAD_OF_B2C),
          translate(BUTTON_LABEL)
        ));
      }
      else {
        dispatch(openModal(
          translate(TITLE_B2B_INSTEAD_OF_ANONYMOUS),
          translate(MESSAGE_B2B_INSTEAD_OF_ANONYMOUS),
          translate(BUTTON_LABEL)
        ));
      }

      return <Navigate to={B2B_SelectStationAndTime.path()} state={{ from: location }} replace />;
    }

    default:
      return;
  }
}
